<template>
    <div class="Rewards" v-Loading="loading">
        <div class="rewards-yue flexible f-csp">
            <div @click="$event.currentTarget.disabled ? '' : toreadfun(9)" v-preventReClick class="flexible aItem-center jc-center rewards-yue-item Coins-item mr20">
                <img class="ic_coins" src="@/assets/inktale/rewadrs/img_jin@2x.png"/>
                <span class="f26 title">{{lang == 'es'?'Coins':lang == 'zh_TW'?'書幣':lang == 'en_ID'?'Koin buku':'Coins'}}</span>
                <span class="f30 ml5">{{checkInInfo.coin}}</span>
                <img class="ic_more" src="@/assets/adoread/rewadrs/ic_more.png"/>
            </div>
            <div @click="$event.currentTarget.disabled ? '' : toreadfun(9)" v-preventReClick class="flexible aItem-center jc-center rewards-yue-item Bonus-item">
                <img class="ic_coins" src="@/assets/inktale/rewadrs/ic_boun.png"/>
                <span class="f26 title">{{lang == 'es'?'Bonus':lang == 'zh_TW'?'書券':lang == 'en_ID'?'Token buku':'Bonus'}}</span>
                <span class="f30 ml5">{{checkInInfo.bonus}}</span>
                <img class="ic_more" src="@/assets/adoread/rewadrs/ic_more.png"/>
            </div>
        </div>
        <div class="rewards-title f-fwb">{{lang == 'es'?'Check-in diario':lang == 'zh_TW'?'簽到':lang == 'en_ID'?'Check-in':'Check in'}}</div>
        <div class="sign-con">
            <div class="rewards-list flexible flex-wrap">
                <div class="rewards-item"
                     v-for="(item) in checkInInfo.signList" :class="item.status==1?'Check-in-item':item.status==2?'Checked-item':item.status==4?'Recheck-item':item.status==5?'Recheck-in-item':'Wait-item'"
                     @click="$event.currentTarget.disabled ? '' : goCheck(item)" v-preventReClick
                ><!--Check-in-item-->
                    <div class="rewards-day f22 f-fwb">{{lang == 'es'?`DÍA${item.day}`:lang == 'zh_TW'?`第${item.day}天`:lang == 'en_ID'?`Hari ke-${item.day}`:`Day${item.day}`}}</div>
                    <div>
                        <img v-if="item.day==1||item.day==3||item.day==4||item.day==6" class="img_bonus mt10" src="@/assets/inktale/rewadrs/ic_boun.png"/>
                        <img v-if="item.day==2||item.day==5" class="ic_gift mt10" src="@/assets/adoread/rewadrs/ic_gift.png"/>
                        <img v-if="item.day==7" class="ic_bonus" src="@/assets/inktale/rewadrs/ic_bouns.png"/>
                    </div>
                    <div class="rewards-money">{{item.awardIntroduction}}</div>
                    <div class="rewards-status" v-if= "item.status==1">{{lang == 'es'?'Check-in diario':lang == 'zh_TW'?'簽到':lang == 'en_ID'?'Check-in':'Check in'}}</div>
                    <div class="rewards-status" v-else-if="item.status==2">{{lang == 'es'?'Terminado':lang == 'zh_TW'?'已簽到':lang == 'en_ID'?'Masuk':'Checked'}}</div>
                    <div class="rewards-status" v-else-if="item.status==4">{{lang == 'es'?'Resurrección':lang == 'zh_TW'?'重新簽到':lang == 'en_ID'?'Masuk kembali':'Recheck'}}</div>
                    <div class="rewards-status" v-else-if="item.status==5">{{lang == 'es'?'Comenzar de nuevo':lang == 'zh_TW'?'補簽':lang == 'en_ID'?'Periksa kembali':'Recheck in'}}</div>
                    <div class="rewards-status" v-else>{{lang == 'es'?'Esperar':lang == 'zh_TW'?'等待':lang == 'en_ID'?'Menunggu':'Wait'}}</div>
                </div>
            </div>
            <div class="rewards-rules">
                <div class="rewards-rules-title flexible aItem-center f24">
                    <img src="@/assets/inktale/rewadrs/ic_rules.png"/>
                    {{lang == 'es'?'Reglas de check-in diario':lang == 'zh_TW'?'簽到規則':lang == 'en_ID'?'Peraturan Check-in':'Check-in rules'}}
                </div>
                <div class="rewards-rules-con f22 mt20" v-html="checkInInfo.ruleIntroduction">
                    {{checkInInfo.ruleIntroduction}}
                </div>
            </div>
        </div>
        <div class="lucky-box" v-if="luckyBoxOpenStatus" @click="toreadfun(0)">
            <img src="@/assets/inktale/rewadrs/lucky_banner.png"/>
        </div>
        <div class="daily-rewards">
            <div class="rewards-title f-fwb">{{lang == 'es'?'Recompensa diaria':lang == 'zh_TW'?'每日獎勵':lang == 'en_ID'?'Hadiah Harian':'Daily Reward'}}</div>
            <div class="taskItem daily-rewards-all flexible aItem-center" v-for="item in rewardlist" v-if="item.type==10">
                <div class="flex">
                    <div class="title f26">{{item.desc}}</div>
                    <div class="time f20">{{item.attach}}/{{rewardlist.length - 1}}</div>
                </div>
                <div class="rewards-btn Claimed" v-if="item.receiveInt == 3">{{lang == 'es'?'Esperar':lang == 'zh_TW'?'等待':lang == 'en_ID'?'Menunggu':'WAIT'}}</div>
                <div class="rewards-btn Claim" v-if="item.receiveInt == 2" @click="$event.currentTarget.disabled ? '' : torewardget(item.type)" v-preventReClick>{{lang == 'es'?'Disponible':lang == 'zh_TW'?'待領取':lang == 'en_ID'?'Go':'CLAIM'}}</div>
                <div class="rewards-btn Claimed" v-if="item.receiveInt == 1">{{lang == 'es'?'Terminado':lang == 'zh_TW'?'已領取':lang == 'en_ID'?'Mengumpulkan':'CLAIMED'}}</div>
            </div>
            <div class="taskList">
                <div class="taskItem mt20 flexible aItem-center" v-for="(item, index) in rewardlist" v-if="index < 6">
                    <div class="flex">
                        <div class="title f26">{{item.desc}}</div>
                        <div class="time f20" v-if="index <= 3">{{item.currentReadingTime}}/{{item.attach}}{{lang == 'es'?'minutos':lang == 'zh_TW'?'分鍾':lang == 'en_ID'?'menit':'mins'}}</div>
                    </div>
                    <div>
                        <div class="rewards-btn toClaim" v-if="item.receiveInt == 3" @click="$event.currentTarget.disabled ? '' : toreadfun(item.type)" v-preventReClick>{{lang == 'es'?'Ir a Recoger':lang == 'zh_TW'?'去完成':lang == 'en_ID'?'Menyelesaikan':'TO CLAIM'}}</div>
                        <div class="rewards-btn Claim" v-if="item.receiveInt == 2" @click="$event.currentTarget.disabled ? '' : torewardget(item.type)" v-preventReClick>{{lang == 'es'?'Disponible':lang == 'zh_TW'?'待領取':lang == 'en_ID'?'Go':'CLAIM'}}</div>
                        <div class="rewards-btn Claimed" v-if="item.receiveInt == 1">{{lang == 'es'?'Terminado':lang == 'zh_TW'?'已領取':lang == 'en_ID'?'Mengumpulkan':'CLAIMED'}}</div>
                        <div class="Bonus f24" :class="item.receiveInt == 1?'Bonus1':item.receiveInt == 2?'Bonus2':item.receiveInt == 3?'Bonus3':''">
                            {{item.bonus}} {{lang == 'es'?'Bonus':lang == 'zh_TW'?'書券':lang == 'en_ID'?'Token buku':'Bonus'}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="checkInPop" v-if="isSign">
            <div class="checkInPop-con">
                <div class="reward-amount f-tac f-fwb mt20">+{{getReward}}<span class="f30 ml5">{{lang == 'es'?'Bonus':lang == 'zh_TW'?'書券':lang == 'en_ID'?'Token buku':'Bonus'}}</span></div>
                <img class="img_pop" src="@/assets/inktale/rewadrs/img_pop_bg_bonus.png"/>
                <div class="got-btn" @click="$event.currentTarget.disabled ? '' : gotFinish(0)" v-preventReClick>
                    {{lang == 'es'?'Recibido':lang == 'zh_TW'?'領取':lang == 'en_ID'?'Menerima':'Get'}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Indicator } from 'mint-ui';
    import {signlist,signperiodic,signperiodicretroactive,rewardlist,rewardget} from '@/api/reward'
    import { getCookie } from "utils/core/kernel";
    export default {
        name: "",
        data: function () {
            return {
                isSign: false,
                checkInInfo: {},
                rewardlist: [],
                getReward: '',
                Claimtype: 1, // 1=签到；2=福利
                loading: true,
                luckyBoxOpenStatus: null,
                lang: 'en_US'
            }
        },
        mounted() {
            // VConsole 默认会挂载到 `window.VConsole` 上
            // var vConsole = new window.VConsole();
            // console.log(vConsole);
            this.getsignlist()
            this.getrewardlist()
            var headers = JSON.parse(getCookie('headers'))
            this.lang = headers.lang
            // this.lang = 'zh_TW'
            // console.log(this.lang)
        },

        methods: {
            /*签到列表*/
            getsignlist () {
                signlist().then(res=>{
                    this.checkInInfo =  res.data
                })
            },
            /*签到方法*/
            goCheck (item) {
                console.log(item.day)
                if (item.day == 7 && item.isToday && item.status == 3) {
                    this.Toast({
                        message: this.lang=='es'?"Debes comprobarlo recargando antes de recibirlo.":
                            this.lang == 'zh_TW'?'你需要通過充值重新簽到才能拿到':
                                this.lang == 'en_ID'?'Anda harus masuk kembali dengan melakukan isi ulang untuk mendapatkannya.':"You need to recheck through recharging before you get it.",
                        duration: 2000,
                        position: "center"
                    });
                } else {
                    if (item.status==2||item.status==3) {return false;}
                    if (item.status==1) {
                        this.Claimtype=1
                        signperiodic('').then(res=>{
                            console.log(res)
                            if (res.success) {
                                this.getReward = res.data
                                this.isHiddenBack(1)
                                this.isSign = true
                            }
                        })
                    } else if (item.status==5) {
                        this.Claimtype=1
                        signperiodicretroactive({retroactiveDay:item.day}).then(res=>{
                            console.log(res)
                            if (res.success) {
                                this.getReward = res.data
                                this.isHiddenBack(1)
                                this.isSign = true
                            }
                        })
                    } else if (item.status==4) {
                        const u = navigator.userAgent;
                        const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                        //android终端
                        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                        //ios终端
                        if (isAndroid) {
                            window.jsBridge.gorecharge({day: item.day, type: 'chongzhi'})  //安卓
                        }
                        if (isiOS) {
                            window.webkit.messageHandlers.gorecharge.postMessage({day: item.day, type: 'chongzhi'}) // 苹果
                        }
                    }
                }
            },
            /*福利列表*/
            getrewardlist () {
                rewardlist().then(res=>{
                    this.loading = false
                    this.luckyBoxOpenStatus = res.data.luckyBoxOpenStatus
                    let readTime = getCookie('headers')?Number(JSON.parse(getCookie('headers')).readTime):0
                    console.log(readTime)
                    if (readTime < 15) {
                        res.data.list[0].currentReadingTime = readTime
                        res.data.list[1].currentReadingTime = readTime
                        res.data.list[2].currentReadingTime = readTime
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >= 15 && readTime < 30) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = readTime
                        res.data.list[2].currentReadingTime = readTime
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >=30 && readTime < 50) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        if (!res.data.list[1].receive) {
                            res.data.list[1].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = 30
                        res.data.list[2].currentReadingTime = readTime
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >= 50 && readTime < 90) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        if (!res.data.list[1].receive) {
                            res.data.list[1].receiveInt = 2
                        }
                        if (!res.data.list[2].receive) {
                            res.data.list[2].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = 30
                        res.data.list[2].currentReadingTime = 50
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >= 90) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        if (!res.data.list[1].receive) {
                            res.data.list[1].receiveInt = 2
                        }
                        if (!res.data.list[2].receive) {
                            res.data.list[2].receiveInt = 2
                        }
                        if (!res.data.list[3].receive) {
                            res.data.list[3].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = 30
                        res.data.list[2].currentReadingTime = 50
                        res.data.list[3].currentReadingTime = 90
                    }
                    this.rewardlist = res.data.list
                })
            },
            /*去完成福利*/
            toreadfun (data) {
                let type = null
                if (data == 9) {
                    type = 'chongzhi'
                } else if (data == 0) {
                    type = 'luckybox'
                } else {
                    type = 'read'
                }
                const u = navigator.userAgent;
                const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                //android终端
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                //ios终端
                if (isAndroid) {
                    window.jsBridge.gorecharge({type: type})  //安卓
                }
                if (isiOS) {
                    window.webkit.messageHandlers.gorecharge.postMessage({type: type}) // 苹果
                }
            },
            /*获取福利*/
            torewardget(data) {
                this.Claimtype=2
                rewardget({type: data}).then(res=>{
                    console.log(res)
                    if (res.success) {
                        this.getReward = res.data
                        this.isHiddenBack(1)
                        this.isSign = true
                        this.checkInInfo.bonus = this.checkInInfo.bonus*1 + res.data*1
                    }
                })
            },
            gotFinish (data) {
                if (this.Claimtype==1) {
                    this.getsignlist()
                } else if (this.Claimtype==2) {
                    this.getrewardlist()
                }
                this.isHiddenBack(data)
                this.isSign = false
            },
            isHiddenBack (data) {
                const u = navigator.userAgent;
                const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                //android终端
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                //ios终端
                if (isAndroid) {
                    window.jsBridge.gorecharge({type: 'showNavigationBack', isHiddenBack: data})  //安卓
                }
                if (isiOS) {
                    window.webkit.messageHandlers.gorecharge.postMessage({type: 'showNavigationBack', isHiddenBack: data}) // 苹果
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.Rewards{
    background: #6D33FF;
    padding-bottom: 65px;
    letter-spacing: 0;
    .rewards-btn{
        width: 244px;
        height: 58px;
        font-size: 28px;
        text-align: center;
        line-height: 58px;
        &.toClaim{
            background: url('../../../assets/inktale/rewadrs/btn_toclaim.png') no-repeat;
            background-size: 244px 58px;
            color: #fff;
        }
        &.Claim{
            background: url('../../../assets/inktale/rewadrs/btn_claim.png') no-repeat;
            background-size: 244px 58px;
            color:#fff;
        }
        &.Claimed{
            background: url('../../../assets/inktale/rewadrs/btn_wait.png') no-repeat;
            background-size: 244px 58px;
            color: #777;
        }
    }
    .img_rewards{
        margin-left: 50px;
        margin-top: 30px;
        width: 250px;
        height: 70px;
    }
    .rewards-yue{
        padding: 0 54px;
        background: url(../../../assets/inktale/rewadrs/title-bg.png) no-repeat;
        background-size: 100% 100%;
        padding-bottom: 40px;
        .rewards-yue-item{
            width: calc((100% - 27px) / 2);
            height: 68px;
            background: url('../../../assets/inktale/rewadrs/img_coins_bg.png') no-repeat;
            background-size: 100% 68px;
            color: #fff;
            position: relative;
            margin-top: 50px;
            .ic_coins{
                width: 106px;
                height: 110px;
                position: absolute;
                left: -5px;
                top: -35px;
            }
            .title{
                margin-left: 60px;
            }
           .ic_more{
               width: 12px;
               height: 20px;
               margin-left: 5px;
           }
            /*&.Coins-item{*/
            /*    background: #6700FF;;*/
            /*}*/
            /*&.Bonus-item{*/
            /*    background: #212223;*/
            /*}*/
        }
    }
    .rewards-title{
        margin-top: 15px;
        margin-left: 30px;
        font-size: 46px;
        font-family: "PingFang SC";
        color: #fff;
    }
    .sign-con{
        background: #fff;
        border-radius:14px;
        margin: 15px 30px 0;
        padding-bottom: 30px;
    }
    .rewards-list{
        padding-top: 55px;
        padding-right: 20px;
        .rewards-item{
            width: calc(25% - 20px);
            height: 192px;
            background: #F5F5F5;
            border-radius: 11px;
            text-align: center;
            position: relative;
            margin-left: 20px;
            margin-bottom: 20px;
            .rewards-day{
                color: #333;
                margin-top: 16px;
            }
            img{
                width: 46px;
                height: 46px;
                &.ic_bonus{
                    width: 132px;
                    height: 55px;
                }
            }
            .rewards-money{
                width: 140px;
                height: 32px;
                background: #e6e6e6;
                border-radius: 16px 16px 16px 0px;
                font-size: 22px;
                margin: auto;
            }
            .rewards-status{
                position: absolute;
                bottom: 0;
                width: 100%;
                border-radius:0 0 11px 11px;
                font-size: 18px;
                height: 37px;
                color: #797979;
                line-height: 37px;
                z-index: 2;
            }
            &.Checked-item{
                .rewards-status{
                    background: #cdcdcd;
                    color: #797979;
                }
            }
            &.Recheck-item,
            &.Recheck-in-item{
                width: calc(25% - 20px - 4px);
                border: 2px solid #7E65FA;
                .rewards-status{
                    background: #7E65FA;
                    color: #fff;
                }
            }
            &.Wait-item{
                .rewards-status{
                    background: #AD7CF6;
                    color: #fff;
                }
            }
            &.Check-in-item{
                width: calc(25% - 20px - 4px);
                border: 2px solid #7E65FA;
                background: linear-gradient(114deg, #87BEFF 0%, #B76CF4 100%);
                .rewards-money{
                    background: #7E65FA;
                    color: #fff;
                }
                .rewards-status{
                    background: #7E65FA;
                    color: #fff;
                }
            }
            &:nth-child(7){
                width: calc(50% - 20px);
                &.Check-in-item{
                    width: calc(50% - 20px - 4px) !important;
                }
            }
        }
    }
    .rewards-rules{
        color: #333;
        margin: 0 20px;
        .rewards-rules-title{
            img{
                width: 30px;
                height: 30px;
                margin-right: 5px;
            }
        }
        .rewards-rules-con{
            line-height: 42px;
            white-space: pre-wrap;
        }
    }
    .lucky-box{
        margin: 40px 30px 0;
        height: 258px;
        img{
            width: 100%;
            height: 100%;
        }
        border-radius: 10px;
    }
    .daily-rewards{
        margin: 0 30px;
        .rewards-title{
            margin-top: 34px;
            margin-left: 0;
        }
        .daily-rewards-all{
            height: 128px;
            background: linear-gradient(270deg, #FFFFFF 0%, #DFDAFF 100%);
            margin-top: 30px;
            padding: 0 30px;
            border-radius: 14px;
            .title{
                margin-top: 0px;
            }
        }
    }
    .taskList{
        background: linear-gradient(90deg, #DDD7FF 0%, #FFFFFF 100%);
        box-shadow: inset 0px 11px 10px 0px rgba(255,255,255,0.19);
        border-radius: 14px;
        padding: 0 30px;
    }
    .taskItem{
        height: 142px;
        border-bottom: 1px solid #CFC8FF;
        .title{
            color: #301E7B;
            font-weight: 500;
        }
        .time{
            color: #6D62A3;
        }
        .Bonus{
            font-size: 22px;
            text-align: center;
            font-weight: 500;
            &.Bonus1{
                color: #BABABA;
            }
            &.Bonus2{
                color: #FE60B2;
            }
            &.Bonus3{
                color: #866AFB;
            }
        }
    }
    .checkInPop{
        top: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        background: #000;
        z-index: 2;
        .checkInPop-con{
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
            text-align: center;
            .img_pop{
                width: 690px;
                height: 648px;
                margin-top: 50px;
            }
            .reward-amount{
                width: 100%;
                position: absolute;
                top: 30px;
                left: 0;
                text-align: center;
                font-size: 100px;
            }
            .got-btn{
                width: 459px;
                height: 82px;
                margin: 40px auto;
                line-height: 80px;
                text-align: center;
                font-size: 30px;
                font-weight: bold;
                color: #fff;
                background: url("../../../assets/inktale/rewadrs/btn_got@2x.png") no-repeat;
                background-size: 459px 82px;
            }
        }
    }
}
</style>
